import { render, staticRenderFns } from "./SearDraw.vue?vue&type=template&id=4c423a94&scoped=true"
import script from "./SearDraw.vue?vue&type=script&lang=js"
export * from "./SearDraw.vue?vue&type=script&lang=js"
import style0 from "./SearDraw.vue?vue&type=style&index=0&id=4c423a94&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c423a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c423a94')) {
      api.createRecord('4c423a94', component.options)
    } else {
      api.reload('4c423a94', component.options)
    }
    module.hot.accept("./SearDraw.vue?vue&type=template&id=4c423a94&scoped=true", function () {
      api.rerender('4c423a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/SearDraw.vue"
export default component.exports